export enum MailingTab {
  CREATE = 'create',
  CAMPAIGNS = 'campaigns',
}
